import React from 'react'
import { ModalAlert } from './styled'

export const alertWarning = (message) => {
  ModalAlert.warning({
    closable: false,
    className: 'modal-alert-message',
    content: message,
    maskClosable: true,
    centered: true,
    icon: false,
    okText: 'ปิด',
  })
}

export const alertError = (message) => {
  ModalAlert.error({
    className: 'modal-alert-message',
    content: message,
    maskClosable: true,
    centered: true,
    icon: false,
    okText: 'ปิด',
  })
}

export const alertSuccess = (message) => {
  ModalAlert.success({
    className: 'modal-alert-message',
    content: message,
    maskClosable: true,
    centered: true,
    icon: false,
    okText: 'ปิด',
  })
}

export const alertInfo = (message) => {
  ModalAlert.info({
    className: 'modal-alert-message',
    content: message,
    maskClosable: true,
    centered: true,
    icon: false,
    okText: 'ปิด',
  })
}

export default ModalAlert



// WEBPACK FOOTER //
// ./src/components/common/modal/index.jsx